import moment from 'moment';
import { DateRange } from './types';

export const DEFAULT_DATE_RANGE: DateRange = {
  startDate: moment('2023-01-01'),
  endDate: moment(),
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 10;

export const CHART_TYPES = {
  LINE: 'line',
  BAR: 'bar',
} as const;

export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export const SORT_KEYS = {
  NAME: 'name',
  VISITS: 'visits',
  RECENT_VISIT: 'recentVisit',
  TOTAL_SPENT: 'totalSpent',
} as const;

export const CHART_COLORS = {
  LIGHT: {
    PRIMARY: '#666666',
    SECONDARY: '#2e2e2e',
    HOVER_PRIMARY: '#c2c2c2',
    HOVER_SECONDARY: '#e0e0e0',
  },
  DARK: {
    PRIMARY: '#c2c2c2',
    SECONDARY: '#7d7d7d',
    HOVER_PRIMARY: '#e0e0e0',
    HOVER_SECONDARY: '#e0e0e0',
  },
} as const;

export const METRIC_ICONS = {
  TOTAL_CUSTOMERS: 'users',
  NEW_CUSTOMERS: 'user-plus',
  REPEAT_CUSTOMERS: 'user-check',
  AVERAGE_SPEND: 'dollar-sign',
  AVERAGE_VISITS: 'trending-up',
} as const;

export const PHONE_BLUR_THRESHOLD = 4;
export const PHONE_UNBLUR_LENGTH = 4;
export const PHONE_SHORT_UNBLUR_LENGTH = 2;

export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '65%',
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      titleColor: '#fff',
      bodyColor: '#fff',
      bodyFont: {
        size: 14,
      },
      padding: 10,
      cornerRadius: 4,
    },
  },
  elements: {
    arc: {
      borderWidth: 0,
    },
  },
} as const;
